import { gql } from '@apollo/client';
import { INTEGRATION_OVERRIDE_FIELDS } from '@/graphql/fragments/integration_overrides';
import { PRICING_OVERRIDE_FIELDS } from '@/graphql/fragments/pricing_overrides';
import { PRICING_TARIFF_FIELDS } from '@/graphql/fragments/pricing_tariffs';
import { PERMISSION_FIELDS } from '@/graphql/fragments/permissions';
import { CLIENT_FIELDS } from '@/graphql/queries/clients';

export const GET_ACTIVE_INTEGRATION_OVERRIDES = gql`
    ${PRICING_OVERRIDE_FIELDS}
    ${INTEGRATION_OVERRIDE_FIELDS}

    query GetActiveIntegrationOverrides($client_id: uuid!) {
        integration: integration_overrides(where: { client_id: { _eq: $client_id } }) {
            ...IntegrationOverrideFields
        }

        pricing: pricing_overrides(where: { client_id: { _eq: $client_id } }) {
            ...PricingOverrideFields
        }

        carrier_pricing: pricing_overrides(where: { partner_client_id: { _eq: $client_id } }) {
            ...PricingOverrideFields
        }
    }
`;

export const GET_SHIPPERS = gql`
    ${CLIENT_FIELDS}

    query GetShippers {
        results: clients(
            where: {
                _and: [
                    { approved: { _eq: true } }
                    { test_acc: { _eq: false } }
                    { user: { roles: { _has_key: "SHIPPER" } } }
                ]
            }
            order_by: { business_name: asc }
        ) {
            ...ClientFields
        }
    }
`;

export const GET_TARIFFS = gql`
    ${PRICING_TARIFF_FIELDS}

    query GetTariffs {
        results: pricing_tariffs(order_by: { created_at: desc }) {
            ...PricingTariffFields
        }
    }
`;

export const GET_TARIFF_PERMISSIONS = gql`
    ${PERMISSION_FIELDS}

    query GetTariffPermissions {
        results: permissions(
            where: { _and: [{ permission_type: { _eq: "TARIFF" } }, { entity_type: { _eq: "CLIENT" } }] }
        ) {
            ...PermissionFields
        }
    }
`;

export const SET_PRICING_OPTIONS = gql`
    ${PRICING_OVERRIDE_FIELDS}

    mutation SetPricingOptions(
        $client_id: uuid!
        $marketplace_tariff_id: uuid!
        $marketplace_margin_flat: float8
        $marketplace_margin_rate: float8
        $options: _pricing_option_overrides!
    ) {
        marketplace: enable_marketplace_pricing_options(
            args: {
                shipper_id: $client_id
                tariff_id: $marketplace_tariff_id
                marketplace_tier: "T3_FULLY_MANAGED"
                add_margin_flat: $marketplace_margin_flat
                add_margin_rate: $marketplace_margin_rate
            }
        ) {
            ...PricingOverrideFields
        }

        options: enable_pricing_options(args: { shipper_id: $client_id, selected: $options }) {
            ...PricingOverrideFields
        }
    }
`;
